import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import { adminTokenKey, api } from "@/lib/api";
import { LOGIN } from "@/constants/testIds";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", form);
      localStorage.setItem(adminTokenKey, data.access_token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error("Invalid admin credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-lg border border-slate-200 p-6 shadow-2xl">
        <div className="w-11 h-11 rounded-lg bg-hop-blue text-white flex items-center justify-center">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="font-display text-3xl font-bold text-hop-blue mt-5">Founder Login</h1>
        <p className="text-sm text-slate-500 mt-2">Private operating dashboard for House of Projects.</p>
        <div className="mt-6 space-y-4">
          <input
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm((s) => ({ ...s, email: e.target.value }))}
            className="hop-input"
            placeholder="Admin email"
            data-testid={LOGIN.emailInput}
          />
          <input
            type="password"
            required
            value={form.password}
            onChange={(e) => setForm((s) => ({ ...s, password: e.target.value }))}
            className="hop-input"
            placeholder="Password"
            data-testid={LOGIN.passwordInput}
          />
        </div>
        <button type="submit" disabled={loading} className="btn-primary btn-emerald w-full justify-center mt-6" data-testid={LOGIN.submitButton}>
          {loading ? "Signing in..." : "Sign in"} <LogIn className="w-4 h-4" />
        </button>
      </form>
    </main>
  );
}
